var _path, _path2, _path3, _path4, _path5;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgViewBoard(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 17 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    stroke: "#797D8A",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.5833 5.358V2.49633C15.5833 1.37008 15.13 0.916748 14.0038 0.916748H11.1421C10.0158 0.916748 9.5625 1.37008 9.5625 2.49633V5.358C9.5625 6.48425 10.0158 6.93758 11.1421 6.93758H14.0038C15.13 6.93758 15.5833 6.48425 15.5833 5.358Z",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7.43758 5.53508V2.31925C7.43758 1.3205 6.98425 0.916748 5.858 0.916748H2.99633C1.87008 0.916748 1.41675 1.3205 1.41675 2.31925V5.528C1.41675 6.53383 1.87008 6.9305 2.99633 6.9305H5.858C6.98425 6.93758 7.43758 6.53383 7.43758 5.53508Z",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M7.43758 13.5038V10.6421C7.43758 9.51583 6.98425 9.0625 5.858 9.0625H2.99633C1.87008 9.0625 1.41675 9.51583 1.41675 10.6421V13.5038C1.41675 14.63 1.87008 15.0833 2.99633 15.0833H5.858C6.98425 15.0833 7.43758 14.63 7.43758 13.5038Z",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M10.625 10.4792H14.875",
    strokeLinecap: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M10.625 13.3125H14.875",
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgViewBoard);
export default __webpack_public_path__ + "static/media/view-board.3726e7154752d390c8155c937068cdf9.svg";
export { ForwardRef as ReactComponent };